import React, { FunctionComponent, ReactNode } from "react";
import { style, classes } from "typestyle";
import { Black, Pink } from "@traceair/tds";

type AlertType = "success" | "failure" | "info";
type Props = {
  type?: AlertType;
  className?: string;
  children?: ReactNode;
};
const Alert: FunctionComponent<Props> = ({
  type,
  className,
  children,
}: Props) => (
  <div
    className={classes(
      style({
        padding: "10px 20px",
        borderRadius: "12px",
        margin: "20px 0",
      }),
      typeToStyle(type),
      className,
    )}
  >
    {children}
  </div>
);

function typeToStyle(type?: AlertType): string {
  switch (type) {
    case "success":
      return style({
        color: "rgb(56, 142, 60)",
        backgroundColor: "rgb(165, 214, 167)",
      });
    case "info":
      return style({
        color: "rgb(69, 90, 100)",
        backgroundColor: "rgb(176, 190, 197)",
      });
    case "failure":
    default:
      return style({ color: Black, backgroundColor: Pink });
  }
}

export default Alert;
